import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { STORAGE_KEYS } from '@/services/storageKeys';

// Import translations from JSON files
import en from './locales/en.json';
import th from './locales/th.json';

const resources = {
  en: {
    translation: en,
  },
  th: {
    translation: th,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

/**
 * Apply brand default language to i18next.
 * Logic moved from App.tsx so i18n initialization is responsible for language selection.
 *
 * Priority:
 * 1. If user manually selected a language and a stored i18n language exists,
 *    respect that language and do nothing.
 * 2. Else if brandDefaultLang is provided, set i18n language to that.
 * 3. Otherwise leave i18n as initialized (fallbackLng or detected language).
 */
export function applyBrandDefaultLanguage(brandDefaultLang?: string) {
  try {
    const hasUserManualSelection =
      localStorage.getItem(STORAGE_KEYS.USER_SELECTED_LANGUAGE) === 'true';
    const storedLanguage = localStorage.getItem(STORAGE_KEYS.I18N_LANGUAGE);

    if (hasUserManualSelection && storedLanguage) {
      // Respect explicit user choice
      if (i18n.language !== storedLanguage) {
        void i18n.changeLanguage(storedLanguage);
      }
      return;
    }

    if (brandDefaultLang) {
      // Use brand default when no explicit user selection
      void i18n.changeLanguage(brandDefaultLang);
      return;
    }

    // Otherwise leave whatever i18n already set (detected or fallback)
    return;
  } catch (error) {
    // Log error so global console.error capture (e.g. Sentry) can record it.
    // Keep this non-throwing to avoid blocking app load.
    console.error('i18n: failed to apply brand language', error);
  }
}

export default i18n;
